/**
 * Decode HTML entities in a string
 *
 * @param {string} html String with HTML entities
 * @returns {string} Decoded string
 */
export function decodeHTMLEntities(html) {
	const txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
}

/**
 * Get WooCommerce placeholder image URL
 *
 * @returns {string} Placeholder image URL
 */
export function getWooCommercePlaceholderImage() {
	const placeholderMeta = document.querySelector('meta[name="wc-placeholder-image"]');
	if (placeholderMeta) {
		return placeholderMeta.getAttribute('content');
	}

	// Fallback to a generic placeholder if meta tag not found
	return '';
}

/**
 * Convert a full-size image URL to thumbnail size
 * WordPress typically stores different image sizes with filename patterns like: image-150x150.jpg
 *
 * @param {string} fullImageUrl Full size image URL
 * @returns {string} Thumbnail image URL
 */
export function getThumbnailImageUrl(fullImageUrl) {
	if (!fullImageUrl) {
		return getWooCommercePlaceholderImage();
	}

	const url = new URL(fullImageUrl);
	// Normalize double slashes in pathname (e.g. //wp-content/ → /wp-content/)
	url.pathname = url.pathname.replace(/\/\/+/g, '/');
	const pathname = url.pathname;
	const lastDotIndex = pathname.lastIndexOf('.');

	if (lastDotIndex === -1) {
		return url.toString();
	}

	const baseName = pathname.substring(0, lastDotIndex);
	const extension = pathname.substring(lastDotIndex);

	// Check if URL has a size suffix like -300x300.jpg or malformed -500x.jpg
	const sizePattern = /-(\d+)x(\d*)$/;
	const match = baseName.match(sizePattern);

	if (match) {
		const width = parseInt(match[1]);
		const height = match[2] ? parseInt(match[2]) : 0;

		// Already the right size, return as-is
		if (width === 300 && height === 300) {
			return url.toString();
		}

		// Convert to 600x600
		const cleanBaseName = baseName.replace(sizePattern, '');
		url.pathname = cleanBaseName + '-300x300' + extension;
		return url.toString();
	}

	// No size suffix found - this is a full-size image
	url.pathname = baseName + '-300x300' + extension;
	return url.toString();
}
